import image1 from '../../../img/services/mens-health/mh-1.png';
import image2 from '../../../img/services/mens-health/mh-2.png';
import image3 from '../../../img/services/mens-health/mh-3.png';
import image4 from '../../../img/services/mens-health/mh-4.png';

const MENS_HEALTH_DATA = {
    sections: [
        {
            imageUrl: image1,
            sectionHeader1: "Prostate conditions",
            sectionCopy1: "Two of the most common disorders of the prostate are prostatis and benign prostatic hyperplasia or BPH. These conditions are similar with symptoms of swelling or enlargement of the prostate gland and difficulty with urine flow and frequency. However, with prostatis there is oftentimes pain during urination or in the abdomen or penis. Treatment for prostatis is usually antibiotics or pain relievers depending on the type of condition. Treatment for BPH involves phytotherapy or Alpha-blockers, or minimally invasive surgical options.",
            sectionId1: "prostate-conditions",
            sectionHeader2: "Male urinary incontinence",
            sectionCopy2: "This broad medical term describes the condition of being unable to control the flow of urine from the body. This problem affects as many as 9-13% of American men. Causes of incontinence can be due to physical activity, prostate enlargement, scarring in the urethra or a dysfunctional bladder. Treatment options available include pharmacological medications, injections or surgical options that include implantations to control incontinence.",
            sectionId2: "male-urinary-incontinence",
            id: 1
        },
        {
            imageUrl: image2,
            sectionHeader1: "Erectile Dysfunction (ED)",
            sectionCopy1: "Erectile Dysfunction (ED) is the inability to attain or maintain an erection of satisfactory quality to complete intercourse. Studies have shown up to 50% of men over the age of 50 have ED. Some cases are mild but others may require intervention to improve one’s sex life. Our specialists can evaluate and plan the right course of treatment. Treatment for ED can sometimes be done through lifestyle changes such as doing more exercise, quitting smoking or losing weight. Other treatment options include oral medication, injections, vacuum device or a penile implant.",
            sectionId1: "erectile-dysfunction",
            sectionHeader2: "Male infertility",
            sectionCopy2: "For couples that are having trouble conceiving, we can evaluate, treat and manage all aspects of infertility. Male infertility can stem from several issues including low sperm count, infection, tumor or hormonal imbalance. After the initial consultation, questionnaire and necessary testing and health assessment have been completed, we can determine the root cause and begin to explore treatment options. Treatments may include surgery, medication or hormone treatments.",
            sectionId2: "male-infertility",
            id: 2
        },
        {
            imageUrl: image3,
            sectionHeader1: "Low testosterone",
            sectionCopy1: "Testosterone levels can begin to decline at age 30 and continue to decease by about 1% each year. Symptoms such as fatigued, trouble concentrating, diminished performance at work or a decreased sex drive, may be an indication of low testosterone We will conduct the A.D.A.M questionnaire to determine if low testosterone is possible. Next, lab tests will be done to determine an appropriate therapy, such as a patch or oral medication, to best improve sperm count.",
            sectionId1: "low-testosterone",
            sectionHeader2: "Premature ejaculation",
            sectionCopy2: "About 30% of all men experience premature ejaculation at some point in their lives. Sometimes, it’s temporary. For others, it’s a lifelong issue. We’re here to provide guidance to help determine if there is a solution. It may be possible to be treated in a single office visit—this is especially true if PE is newly acquired, rather than a lifelong problem. One thing to note, PE is a different condition than erectile dysfunction (ED). A physician will be able to confirm if the issue is PE or ED.",
            sectionId2: "premature-ejaculation",
            id: 3
        },
        {
            imageUrl: image4,
            sectionHeader1: "Peyronie’s disease",
            sectionCopy1: "Peyronie’s disease is a condition that is characterized by deformity of the penis with or without erection. This can include curvature, indentation or loss of length. Peyronie’s is most common in men over 50. Many things can determine the treatment plan, including the degree of the curvature, the severity of penile shortening, any narrowing and whether erectile dysfunction is also an issue. Several treatment options are available with the goal of regaining or maintaining sexual function through straightening the penis.",
            sectionId1: "peyronies-disease",
            sectionHeader2: "Kidney stones",
            sectionCopy2: "Pain from kidney stones can be intense and usually starts with a sharp cramping and discomfort in the back, side or lower abdomen. Stones occur more frequently in men and prevalence of stones raises dramatically as men enter their 40’s and continues to rise into their 70’s. Most kidney stones can pass without needing a doctor’s intervention. However, some cause complications and pain that require treatment such as lithotripsy to break up the stones or surgery in some cases. Once you develop a kidney stone other stones are likely to occur.",
            sectionId2: "kidney-stones",
            id: 4
        },
        {
            imageUrl: "",
            sectionHeader1: "Vasectomy",
            sectionCopy1: "Vasectomy is a form of male birth control done through minimally invasive surgery. The procedure has a low risk of complications and can usually be performed in an outpatient setting under local anesthesia. Vasectomy offers no protection from sexually transmitted infections. Vasectomy is considered a permanent form of male birth control and is nearly 100% effective in preventing pregnancy. Since this procedure is not always reversible, it’s important that the patient be sure they don’t want to father a child in the future before considering a vasectomy.",
            sectionId1: "vasectomy",
            sectionHeader2: "Vasectomy reversal",
            sectionCopy2: "Vasectomy reversal undoes a vasectomy by reconnecting the tubes that carry sperm from the testicles into the semen. After a successful vasectomy reversal, sperm are again present in the semen and pregnancy may be possible for a couple. Reported pregnancy rates after vasectomy reversal range from 40 to 90 percent, with success depending on the type of vasectomy and experience of the doctor performing the surgery.",
            sectionId2: "vasectomy-reversal",
            id: 5
        }
    ],
    buttons: [
        {
            id: 1,
            buttonCopy: "Prostate conditions",
            buttonLink: "#prostate-conditions"
        },
        {
            id: 2,
            buttonCopy: "Male urinary incontinence",
            buttonLink: "#male-urinary-incontinence"
        },
        {
            id: 3,
            buttonCopy: "Erectile Dysfunction (ED)",
            buttonLink: "#erectile-dysfunction"
        },
        {
            id: 4,
            buttonCopy: "Male infertility",
            buttonLink: "#male-infertility"
        },
        {
            id: 5,
            buttonCopy: "Low Testosterone",
            buttonLink: "#low-testosterone"
        },
        {
            id: 6,
            buttonCopy: "Premature ejaculation",
            buttonLink: "#premature-ejaculation"
        },
        {
            id: 7,
            buttonCopy: "Peyronie's disease",
            buttonLink: "#Peyronies-disease"
        },
        {
            id: 8,
            buttonCopy: "Kidney stones",
            buttonLink: "#kidney-stones"
        },
        {
            id: 9,
            buttonCopy: "Vasectomy",
            buttonLink: "#vasectomy"
        },
        {
            id: 10,
            buttonCopy: "Vasectomy reversal",
            buttonLink: "#vasectomy-reversal"
        }
    ]
}

export default MENS_HEALTH_DATA;